<template>
    <h2 class="page_title">
        {{ value }}
    </h2>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true
        }
    }
};
</script>
